import { CreateActionParams } from '../../actions';

export async function handlePreviewFlow({
  context: { wixSdkAdapter },
}: CreateActionParams) {
  await wixSdkAdapter.openEcomCheckoutPreviewModal();
}
